import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  fetchCurrency,
  updateBalances,
  getBalance,
  debitList,
  creditList,
};

let g_balanceMap: { [key: string]: number } = {};

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  UserStore.addChangeListener(_onUserChange);
  done && done();
}
function _onUserChange(reason: string) {
  if (reason === 'logout') {
    g_balanceMap = {};
    _emit('update');
  }
}

function isReady() {
  return true;
}
function fetchCurrency(user_currency_id: string, done = null) {
  if (UserStore.isLoggedIn()) {
    const opts = {
      url: `/client/1/user_currency/${user_currency_id}`,
    };
    UserStore.get(opts, (err, body) => {
      if (err) {
        util.errorLog('UserCurrencyStore.fetchCurrencyList: err:', err);
      } else if (body) {
        g_balanceMap[user_currency_id] = body[user_currency_id] || 0;
        _emit('update');
      }
      done && done(err);
    });
  } else {
    done && done('not_logged_in');
  }
}
function updateBalances(balance_map: any) {
  if (balance_map) {
    Object.assign(g_balanceMap, balance_map);
    _emit('update');
  }
}
function getBalance(user_currency_id: string) {
  return g_balanceMap[user_currency_id];
}

function debitList(list) {
  if (list) {
    let has_updated = false;
    list.forEach(item => {
      const { user_currency_id, quantity } = item;
      if (user_currency_id && quantity && user_currency_id in g_balanceMap) {
        g_balanceMap[user_currency_id] -= quantity;
        has_updated = true;
      }
    });
    if (has_updated) {
      _emit('update');
    }
  }
}
function creditList(list) {
  if (list) {
    let has_updated = false;
    list.forEach(item => {
      const { user_currency_id, quantity } = item;
      if (user_currency_id && quantity) {
        const old = g_balanceMap[user_currency_id] || 0;
        g_balanceMap[user_currency_id] = old + quantity;
        has_updated = true;
      }
    });
    if (has_updated) {
      _emit('update');
    }
  }
}
